"use strict";
/**
 * Upload File Info
 *
 * The shape of information passed from the browser to the upload API.
 */
Object.defineProperty(exports, "__esModule", { value: true });
